<mat-card>
    <mat-card-header>
        <mat-card-title>{{action.failedReason | param:'mandateFailedReasons'}}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content *ngIf="action.note">
        <p>{{action.note}}</p>
    </mat-card-content>
</mat-card>